import { createApp } from 'vue'
import Root from './App.vue'

const app = createApp(Root)

app.mount('#app')
